export const Footer = () => (
  <footer className="bg-ivory py-12 px-6 sm:px-10 lg:px-16 border-t border-petrol/10" data-testid="footer-section">
    <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
      <p className="font-mono text-xs text-muted2">© {new Date().getFullYear()} Dott. Armando Mattia Ninni D.O. — Formazione in Osteopatia Pediatrica</p>
      <a href="/admin" data-testid="footer-admin-link" className="font-mono text-xs text-muted2 hover:text-coral transition-colors">Area riservata</a>
    </div>
  </footer>
);
